import { useContext } from 'react';
import userVehicleContext from '~/context/vdp/UserVehicleContext';
import useIsNotAvailableForImmediatePurchase from './useIsNotAvailableForImmediatePurchase';

export default function useCanShowDeliveryAndPickupInfo() {
  const isNotPurchasable = useIsNotAvailableForImmediatePurchase();
  const { isLoaded } = useContext(userVehicleContext).vehicleAvailability;

  return !isNotPurchasable && isLoaded;
}
